'use client'
import InitializeThemes from './InitializeThemes'
import CommonDataInitializer from './CommonDataInitializer'
import InitializeAccountData from './InitializeAccountData'
import AddressStateInitializer from './AddressStateInitializer'

export default function ReduxStoreInitializers(props) {
  const {
    websiteTheme,
    organizationData,
    loading,
    currentPath,
    googleAnalyticsAccountKey,
    dynamicStyles,
    dir,
    domain,
    accountData,
    navigationData,
    footerData,
    homeData,
    announcementData,
    address,
    storeId,
    dictionaryList,
    currentTheme,
    underMaintenace,
    fbAnalyticsId,
    conversionArray,
    scriptBody,
    selectedLanguage,
    isStoreAvailable,
    orgStatusCode,
  } = props
  return (
    <>
      <InitializeAccountData accountData={accountData?.customer} />
      <InitializeThemes
        currentTheme={currentTheme}
        websiteTheme={websiteTheme}
      />
      <CommonDataInitializer
        defaultData={{
          organizationData,
          navigationData,
          footerData,
          homeData,
          announcementData,
        }}
      />
      <AddressStateInitializer
        organizationData={organizationData}
        checkoutAddress={address}
      />
    </>
  )
}
